import { takeEvery, put, delay } from 'redux-saga/effects';
import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { mkScheduledTransaction } from 'data/scheduledTransactions/scheduledTransactionsTypes';
import * as transactionActions from 'data/transactions/actions';
import { transformRequestDataToTransaction, transformTransactionToRequestData } from 'data/transactions/transformers';
import * as actions from './scheduledTransactionsActions';
import { getLastSyncDate } from './scheduledTransactionsSelectors';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'scheduled transactions',
  resourceBaseUrl: '/scheduled-transactions',
  getLastSyncDate,
  transformResourceToRequestData: (resource) => ({
    ...(resource.toJS ? resource.toJS() : resource),
    ...(resource.transaction && {transaction: transformTransactionToRequestData(resource.transaction)}),
  }),
  transformResponseToResources: (response: any) => response.data.resources.map((data) => mkScheduledTransaction({
    ...data,
    transaction: transformRequestDataToTransaction(data.transaction),
  })),
  ...props,
});

export function* getScheduledTransactionsActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.getScheduledTransactionsSuccess,
    failureAction: actions.getScheduledTransactionsFailure,
  });
  yield takeEvery(actions.getScheduledTransactions, getQcsSyncResources, config);
}

export function* createScheduledTransactionActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.createScheduledTransactionSuccess,
    failureAction: actions.createScheduledTransactionFailure,
  });
  yield takeEvery(actions.createScheduledTransaction, qcsSyncCreateResource, config);
}

export function* updateScheduledTransactionActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.updateScheduledTransactionSuccess,
    failureAction: actions.updateScheduledTransactionFailure,
  });
  yield takeEvery(actions.updateScheduledTransaction, qcsSyncUpdateResource, config);
}

export function* deleteScheduledTransactionActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.deleteScheduledTransactionSuccess,
    failureAction: actions.deleteScheduledTransactionFailure,
  });
  yield takeEvery(actions.deleteScheduledTransaction, qcsSyncDeleteResource, config);
}

export function* triggerGetTransactionsAction() {
  yield delay(3000); // dirty hack: we have to wait for random number of seconds while QCS generates transactions asynchronously
  yield put(transactionActions.getTransactions(undefined, { context: 'scheduledTransactions' }));
}

export function* createScheduledTransactionSuccessActionWatcher() {
  yield takeEvery(actions.createScheduledTransactionSuccess, triggerGetTransactionsAction);
}
export function* updateScheduledTransactionSuccessActionWatcher() {
  yield takeEvery(actions.updateScheduledTransactionSuccess, triggerGetTransactionsAction);
}
export function* deleteScheduledTransactionSuccessActionWatcher() {
  yield takeEvery(actions.deleteScheduledTransactionSuccess, triggerGetTransactionsAction);
}
export function* createRecurringTransactionSuccessActionWatcher() {
  yield takeEvery(actions.createBillScoutScheduleSuccess, triggerGetTransactionsAction);
}

export function* createRecurringTransactionWatcher() {
  const config = mkQcsSyncResourceConfig({
    resourceName: 'bill scout',
    resourceBaseUrl: '/bill-scout/create-recurring-transaction',
    transformResourceToRequestData: (resource) => ({ clientId: resource.clientId }),
    successAction: actions.createBillScoutScheduleSuccess,
    failureAction: actions.createBillScoutScheduleFailure,
    getLastSyncDate: () => null,
  });
  yield takeEvery(actions.createBillScoutSchedule, qcsSyncUpdateResource, config);
}

export default [
  createScheduledTransactionActionWatcher,
  createScheduledTransactionSuccessActionWatcher,
  updateScheduledTransactionActionWatcher,
  updateScheduledTransactionSuccessActionWatcher,
  deleteScheduledTransactionActionWatcher,
  deleteScheduledTransactionSuccessActionWatcher,
  getScheduledTransactionsActionWatcher,
  createRecurringTransactionSuccessActionWatcher,
  createRecurringTransactionWatcher,
];
